import { formatDate } from '@angular/common';
import { isValid } from 'date-fns';

import { I18nLocaleFactory } from '../../../i18n/i18n.module';
import { I18nService } from '../../../i18n/i18n.service';
import { epicDependencies } from '../../../store';
import { PeriodType } from '../../../widget/date-range.widget.model';

export function formatCacheDate(
    periodTypeId: number,
    start: Date,
    end: Date,
): string {
    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);

    if (!isValid(start) || !isValid(end)) {
        return '';
    }

    /* TODO revise. move to api or have sp changed. trying not to have period type const referenced in report ui module */
    let startFormat: string = null;
    let endFormat = 'yyyy-MM-dd';
    switch (periodTypeId) {
        case PeriodType.DAY:
            endFormat = 'EEE MMM dd y';
            break;
        case PeriodType.WEEK:
            startFormat = 'MMM dd';
            endFormat = 'MMM dd y';
            break;
        case PeriodType.MONTH:
            endFormat = 'MMMM y';
            break;
        case PeriodType.QUARTER:
            startFormat = 'MMM dd y';
            endFormat = 'MMM dd y';
            break;
        case PeriodType.YEAR:
            endFormat = 'y';
            break;
    }

    const locale = I18nLocaleFactory(i18nService);
    const parts: string[] = [];

    if (startFormat != null) {
        parts.push(formatDate(start, startFormat, locale));
    }

    parts.push(formatDate(end, endFormat, locale));

    return parts.join(' - ');
}
